import axios from "axios";
import qs from "qs";
const API_VERSION = "/api/v1";

const API_BACK = axios.create({
  baseURL:
    (process.env.REACT_APP_BACK_API || "https://stage-dev.tx-portal.com/back") +
    API_VERSION,
  headers: { "Content-Type": "application/json" },
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
});

API_BACK.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API_BACK;
